<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input2">
				<el-select v-model="checkType" placeholder="请选择">
					<el-option label="车牌号" value="1"> </el-option>
				</el-select>
			</div>
			<div class="top_input3">
				<el-select v-model="checkTypeValue" filterable placeholder="请选择" clearable>
					<el-option v-for="(item, index) in checkTypeList" :key="index" :label="item.value"
						:value="item.index">
						<!-- <span style="float: left">{{ item.value }}</span>
						<span style="
						          float: right;
						          color: var(--el-text-color-secondary);
						          font-size: 13px;
						        ">
							{{ item.index }}
						</span> -->
					</el-option>
				</el-select>
				<!-- <el-input type="text" placeholder="请输入" v-model="searchWord"></el-input> -->
			</div>
			<div class="top_input5">
				<el-select v-model="ddtjType" placeholder="请选择检验有效期状态">
					<el-option label="正常" value="1"> </el-option>
					<el-option label="即将过期" value="2"> </el-option>
					<el-option label="已过期" value="3"> </el-option>
				</el-select>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div v-if="permissionItem.add" class="add_btn" @click="add">添加</div>
			<div v-if="permissionItem.add" class="add_btn" @click="detail(1)">详情</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					:default-sort="{ prop: 'whType', order: 'descending' }" v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<el-table-column prop="whId" label="序号" width="80"></el-table-column>
					<el-table-column prop="whName" label="车牌号码" width="150"></el-table-column>
					<el-table-column prop="whName" label="道路运输证号" width="150"></el-table-column>
					<el-table-column prop="whType" label="车辆行驶证号(VIN)" width="150">
						<template #default="scope">
							<span v-if="scope.row.whType == 'gsloa'" style="color: #E36A19;">LNG装货点</span>
							<span v-else-if="scope.row.whType == 'gsunl'" style="color: #0000ff;">LNG卸货点</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column prop="whProviderName" label="检验有效期" width="120"></el-table-column>
					<el-table-column prop="whContact" label="剩余时间" width="120"></el-table-column>
					<el-table-column prop="whPhone" label="检验单位名称" width="130"></el-table-column>
					<el-table-column prop="whContact2" label="检验日期" width="120"></el-table-column>
					<el-table-column prop="whPhone2" label="检验费用(元)" width="120"></el-table-column>
					<el-table-column prop="whAddr" label="有效期状态" width="130">
						<template #default="scope">
							<div class="cell-style">{{ scope.row.whAddr }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="whRemark" label="投保经办人" width="120"></el-table-column>
					<el-table-column prop="whCretime" label="更新日期" width="120"></el-table-column>
					<el-table-column label="操作" fixed="right" width="150">
						<template #default="scope">
							<span v-if="permissionItem.edit" class="default_color pointer m-right10"
								v-on:click="edit(scope.row.whId)">编辑</span>
							<span v-if="permissionItem.list" class="default_color pointer m-right10"
								v-on:click="detail(scope.row.whId)">详情</span>
							<span v-if="permissionItem.del" class="col-FF1A1A pointer"
								v-on:click="del(scope.row.whId)">删除</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "inspection",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "orgManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,
				cocId: "",
				cocList: [], //客商列表
				checkType: "1",
				checkTypeValue: "",
				checkTypeList: [],

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "siteManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "siteManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "siteManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "siteManage:del") {
						data.permissionItem.del = true;
					}
				});

				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					//getData();
					checkTypeChange("1");

				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				// if (!data.permissionItem.list) {
				// 	proxy.$message.error("没有查询站点列表权限！");
				// 	return;
				// }

				// let params = {
				// 	searchWord: data.searchWord,
				// 	page: data.page,
				// 	limit: data.pageSize,
				// 	whTypes: 'gsloa,gsunl',
				// 	whProvider: data.cocId,
				// 	// roleOrg: store.state.userInfo.orgId,
				// };
				// const r = await proxy.$http.get(apiObj.siteList, params);
				// console.log(r);
				// if (r.code === 0) {
				// 	r.rows.forEach((el) => {
				// 		el.whStatusBoolen = el.whStatus == 0 ? true : false;
				// 	});
				// 	data.tableData = r.rows;
				// 	data.totalCount = r.total;
				// }

				// getCocList();
			};

			const checkTypeChange = async (value) => {
				data.checkTypeValue = "";
				if (value == "1") {
					//获取车辆
					let params = {
						searchWord: "",
						page: 1,
						limit: "10000",
					};
					const res = await proxy.$http.get(apiObj.vehicleList, params);
					console.log(res);
					data.checkTypeList = [];
					if (res.code === 0 || res.respCode === '0000') {
						res.rows.forEach((el) => {
							data.checkTypeList.push({
								value: el.vehHeadNo,
								index: el.vehHeadNo,
							});
						});
					}
				}
			};

			//获取所属托运商
			const getCocList = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询站点列表权限！");
					return;
				}

				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.cocList = res.rows;
				}
			};

			// 添加 根目录
			const add = () => {
				if (!data.permissionItem.add) {
					proxy.$message.error("没有站点添加权限！");
					return;
				}

				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有站点编辑权限！");
					return;
				}

				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有站点查询权限！");
					return;
				}

				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//菜单删除
			const del = (whId) => {
				if (!data.permissionItem.del) {
					proxy.$message.error("没有站点删除权限！");
					return;
				}

				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							whId: whId,
						};
						const r = await proxy.$http.postFormData(apiObj.siteDel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const updateState = (row) => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有站点编辑权限！");
					return;
				}

				proxy.$confirm(
					`您确定执行${!row.whStatusBoolen ? "启用" : "禁用"}操作，是否继续?`,
					"提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					proxy.$http
						.postFormData(
							"/biz/bdzl/warehouse/updateStatus", {
								whId: row.whId,
								status: row.whStatusBoolen ? 1 : 0
							}, {
								headers: {
									"Content-Type": "application/x-www-form-urlencoded"
								},
							}
						)
						.then((res) => {
							if (res.code == 0 || res.respCode == "0000") {
								proxy.$message.success(res.msg || res.respMsg);
								getData();
							} else {
								proxy.$message.info(res.msg || res.respMsg);
							}
						});
				});
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				updateState,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}
</style>